import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import Navbar from './components/navbar.jsx';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import Products from './pages/Products';
import './App.css';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/orderSuccess.jsx';
import ProductDetail from './pages/ProductDetails.jsx';
import Wishlist from './pages/Wishlist';
import Register from './pages/Register';
import VerifyOtp from './pages/VerifyOtp';
import CustomerLogin from './pages/CustomerLogin';
import OrderHistory from './pages/OrderHistory';
import NotFound from './pages/NotFound';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { ToastProvider } from './contexts/ToastContext.jsx';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';

import ApiStatusGate from './components/ApiStatusGate';
import AppBranding from './components/AppBranding';

function App() {
  return (
    <Router>
      <AppBranding />
      <ScrollToTop />
      <ToastProvider>
        <ApiStatusGate>
        <CartProvider>
          <div className="app-layout">
            <Navbar />
            <main className="main-content">
              <ErrorBoundary>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/order-success" element={<OrderSuccess />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/verify-otp" element={<VerifyOtp />} />
                  <Route path="/login" element={<CustomerLogin />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/orders" element={<OrderHistory />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsOfService />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </ErrorBoundary>
            </main>
            <Footer />
            <WhatsAppButton />
          </div>
        </CartProvider>
        </ApiStatusGate>
      </ToastProvider>
    </Router>
  );
}

export default App;
